(() => {
  document.querySelectorAll('[data-system-buybox-post-atc]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const scope = root.closest('[data-product-info]');
    if (!scope) return;
    scope.classList.add('system-buybox-scope');
    let queued = false;
    const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
    function refresh() {
      const cta = scope.querySelector('#CTA_kopstorm');
      const holder = cta?.querySelector('.product__submit__holder');
      const button = holder?.querySelector('[data-add-to-cart]');
      const shipping = scope.querySelector('[data-shipping-usp]');
      if (holder) {
        cta.classList.add('system-buybox-cta');
        holder.classList.add('system-buybox-atc');
        const buttons = holder.querySelector('.product__submit__buttons');
        if (shipping && buttons && shipping.nextElementSibling !== buttons) holder.insertBefore(shipping, buttons);
      }
      const bar = scope.querySelector('.kaching-bundles__bar--selected')
        || scope.querySelector('input[name^="kaching-bundles-deal"]:checked')?.closest('.kaching-bundles__bar');
      const price = bar?.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
      const compare = bar?.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim() || '';
      if (price && button) {
        let pill = button.querySelector('.system-buybox-atc__price');
        if (!pill) {
          pill = document.createElement('span');
          pill.className = 'system-buybox-atc__price';
          pill.innerHTML = '<span class="system-buybox-atc__compare"></span><span class="system-buybox-atc__current"></span>';
          button.append(pill);
        }
        setText(pill.firstElementChild, compare !== price ? compare : '');
        setText(pill.lastElementChild, price);
        const header = scope.querySelector('[data-system-product-price], [data-product-price]');
        const headerCompare = scope.querySelector('[data-system-compare-price], [data-compare-price]');
        if (header) { header.setAttribute('data-system-product-price',''); header.removeAttribute('data-product-price'); setText(header,price); }
        if (headerCompare) { headerCompare.setAttribute('data-system-compare-price',''); headerCompare.removeAttribute('data-compare-price'); setText(headerCompare,compare); headerCompare.classList.toggle('hidden',!compare || compare === price); }
      }
      // Apply CCF2's native link layout only to this rendered PDP instance.
      // Kaching builds the one-time cart payload without changing the main
      // button's selected subscription or the shared app configuration.
      const block = scope.querySelector('kaching-bundles-block');
      if (block) {
        try {
          const deal = JSON.parse(block.getAttribute('deal-block'));
          if (deal.subscriptionsEnabled && deal.subscriptions && deal.subscriptions.layout !== 'link') {
            deal.subscriptions = {
              ...deal.subscriptions,
              layout: 'link',
              subscribeByDefault: true,
              oneTimeTitle: 'Buy Once — {{new_total}} (No Savings)',
              showPrices: false
            };
            block.setAttribute('deal-block', JSON.stringify(deal));
          }
        } catch (_) { /* Keep the native subscription UI usable if settings change. */ }
      }

    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; refresh(); });
    }
    new MutationObserver(records => {
      if (records.some(record => record.type !== 'attributes' || (record.target.nodeType === 1 ? record.target : record.target.parentElement)?.closest('kaching-bundles-block, .kaching-bundles__block'))) schedule();
    }).observe(scope,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','aria-checked','deal-block']});
    scope.addEventListener('change',schedule);
    refresh();
  });
})();
